import axios from "axios";

export default {
  namespaced: true,
  state: {
    purchasereceipts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    purchasereceiptsMessage: ''
  },
  mutations: {
    RECEIVED_PURCHASERECEIPTS(state, payload) {
      state.purchasereceipts = payload;
      state.isReceiving = false;
    },
    RECEIVING_PURCHASERECEIPTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_PURCHASERECEIPT(state) {
      state.isReceiving = true;
    },
    RECEIVED_PURCHASERECEIPT(state, payload) {
      state = Object.assign(state, {
        purchasereceipts: [...state.purchasereceipts, payload],
        isReceiving: false,
      })
    },

    UPDATED_PURCHASERECEIPTS(state, payload) {
      console.log(state.purchasereceipts);
      console.log(payload);
      let index = state.purchasereceipts.findIndex(purchasereceipt => purchasereceipt._id === payload._id);
      state = Object.assign(state, {
        purchasereceipts: state.purchasereceipts.map((purchasereceipt, i) => {
          if (i === index) {
            return Object.assign({}, purchasereceipt, payload);
          }
          return purchasereceipt;
        }),
        isUpdating: false,
        purchasereceiptsMessage: 'PurchaseReceipts has been updating!',
      })
    },
    UPDATING_PURCHASERECEIPTS(state) {
      state.isUpdating = true;
    },
    DELETED_PURCHASERECEIPTS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.purchasereceipts.findIndex(purchasereceipt => purchasereceipt._id === payload._id);
      console.log(indexToDelete);
      let purchasereceipts = [...state.purchasereceipts];
      purchasereceipts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        purchasereceipts: [...purchasereceipts],
        isDeleting: false,
        idToDelete: null,
        purchasereceiptsMessage: 'PurchaseReceipt has been Deleted!',
      });
    },
    DELETING_PURCHASERECEIPTS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertPurchaseReceiptRequest({dispatch}, payload) {
      dispatch("receivingPurchaseReceipts");
      let token = localStorage.getItem('token');
      console.log('111111', payload)
      let url = 'https://api.accountxc.com:3100/insert/purchasereceipt/' + payload.purchasereceipt.purchaseorderid;
      console.log(url)
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {dispatch("receivePurchaseReceipt", response.data);})
      .catch((error) => {this.alertmessage = error;});	
    },
    async insertPOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        console.log(payload)
        let id = payload.id;
        delete payload['id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/potransaction/" + id;
        console.log(url)
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        console.log(response.data);
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    deletePurchaseReceiptRequest({dispatch}, payload) {
      dispatch("deletingPurchaseReceipt", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/purchasereceipt/' + payload._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      let del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(response=>{
        dispatch("deletePurchaseReceipt", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deletePOTransactionRequest({dispatch}, id) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/potransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    getPurchaseReceiptsRequest({dispatch}) {
      console.log('here')
      dispatch("receivingPurchaseReceipts");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/purchasereceipts';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        console.log(res.data)
        dispatch("receivePurchaseReceipts", res.data);
      })
    },
    async updatePurchaseReceiptRequest({dispatch}, payload) {
      dispatch("updatingPurchaseReceipt");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/purchasereceipt/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers,data: payload})
      .then((response)=> {
        dispatch("updatePurchaseReceipt", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updatePOTradeRequest({dispatch}, payload) {
      dispatch("updatingPurchaseReceipt");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/purchasereceipt/trade/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "put",url: url,headers: headers,data: payload})
      .then((response)=> {
        dispatch("updatePurchaseReceipt", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updatePOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        var id = payload.id;
        delete payload['id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/update/potransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "put", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    receivePurchaseReceipts({commit}, payload) {
      commit("RECEIVED_PURCHASERECEIPTS", payload)
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivingPurchaseReceipts({commit}) {
      commit("RECEIVING_PURCHASERECEIPTS")
    },
    receivePurchaseReceipt({commit}, payload) {
      commit("RECEIVED_PURCHASERECEIPT", payload)
    },
    receivingPurchaseReceipt({commit}) {
      commit("RECEIVING_PURCHASERECEIPTS")
    },
    updatePurchaseReceipt({commit}, payload) {
      commit("UPDATED_PURCHASERECEIPTS", payload)
    },
    updatingPurchaseReceipt({commit}) {
      commit("UPDATING_PURCHASERECEIPTS")
    },
    deletePurchaseReceipt({commit}, payload) {
      commit("DELETED_PURCHASERECEIPTS", payload)
    },
    deletingPurchaseReceipt({commit}, payload) {
      commit("DELETING_PURCHASERECEIPTS", payload)
    }
  },
};
